window.showGeolocationModal = function(modalId) {
  var modalEl = document.getElementById(modalId);

  if (!modalEl) {
    return;
  }

  var modal = new bootstrap.Modal(modalEl);
  if (!modal) {
    return;
  }
  GeoLocationModalWireUpOutsideClick(modal, modalEl);
  modal.show();
}

function CheckGeoLocationCheck()
{

  if(HasLocalStorageGeoLocation())
  {
    console.log("CheckGeoLocationCheck has already been run");
    return;
  }
  
  fetch('https://api.ipgeolocation.io/ipgeo')
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        console.error('Geo Location Network response was Bad');
      }
    })
    .then(data => CheckForLoadGeoLocationModal(data))
    .catch(error => console.error('Error:', error));
}

function HasLocalStorageGeoLocation()
{
    if(localStorage.getItem('nwGeoData'))
      return true;

  return false;
}

function CheckForLoadGeoLocationModal(data)
{
  console.log('CheckForLoadGeoLocationModal');
  //console.log(data);

  localStorage.setItem('nwGeoData', JSON.stringify(data));
  
  if(data.country_code3 == "USA")
  {
    console.log('location USA do not display modal');
    return;
  }
  if(data.country_code3 == "CAN")
  {
    GeoLocationModalLoadCanada();
    return;
  }

  //all else iHerb display
  GeoLocationModalLoadIherb();
}

function GeoLocationModalLoadIherb()
{
  console.log('location international display iHerb modal');
  window.showGeolocationModal('geolocationModal-iherb');

}

function GeoLocationModalLoadCanada()
{
  console.log('location CAN display Canada modal');
  window.showGeolocationModal('geolocationModal-CA');
}


function GeoLocationModalWireUpOutsideClick(modal, modalEl)
{
    var GeoLocationModalClickHandler = document.addEventListener('click', function() {

      if(modalEl.matches(':hover'))
        return;
      
      console.log('GeoLocationModalWireUpOutsideClick');
      modal.hide();
    });
}


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.geo-modal-close').forEach(function(el) {
    el.addEventListener('click', function(ev) {
      ev.stopPropagation();

      var modalEl = el.closest('.geolocation-modal');
      if (!modalEl) {
        return;
      }

      var geolocationModal = bootstrap.Modal.getInstance(modalEl);
      if (!geolocationModal) {
        return;
      }

      geolocationModal.hide();
    });
  });
});

window.addEventListener('load', function() {
    CheckGeoLocationCheck();
});

